import { Group } from '@radix-ui/react-select';
import { ComponentPropsWithoutRef } from 'react';

type Props = ComponentPropsWithoutRef<typeof Group>;
export const SelectGroup = (props: Props) => {
    return <Group data-testid="select-group" {...props} />;
};
